export default __webpack_public_path__ + "static/media/vnpost.aaf6c68f.jpg";